/** Polyfill for ES2017 'Object.values' */
export const objectValues = (obj: any) => {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
};
